export enum MONTH_NAMES {
  JANUARY = "january",
  FEBRUARY = "february",
  MARCH = "march",
  APIL = "april",
  MAY = "may",
  JUNE = "june",
  JULY = "july",
  AUGUST = "august",
  SEPTEMBRE = "september",
  OCTOBER = "october",
  NOVEMBER = "november",
  DECEMBER = "december",
}

export const monthOrderedList: MONTH_NAMES[] = [
  MONTH_NAMES.JANUARY,
  MONTH_NAMES.FEBRUARY,
  MONTH_NAMES.MARCH,
  MONTH_NAMES.APIL,
  MONTH_NAMES.MAY,
  MONTH_NAMES.JUNE,
  MONTH_NAMES.JULY,
  MONTH_NAMES.AUGUST,
  MONTH_NAMES.SEPTEMBRE,
  MONTH_NAMES.OCTOBER,
  MONTH_NAMES.NOVEMBER,
  MONTH_NAMES.DECEMBER,
];
